import React from 'react';
import { MenuList, MenuListProps } from '@chakra-ui/react';

const DropdownList: React.FC<MenuListProps> = (props) => {
  const { children, ...rest } = props;
  return <MenuList {...rest}>{children}</MenuList>;
};

export default DropdownList;
